module.exports = __webpack_public_path__ + "static/img/13.a20b21c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/13.png
// module id = W9mm
// module chunks = 0